import React, { useState, useEffect } from 'react';
import ShippingAddressPopup from './popupfoldier/ShippingAddressPopup.js';
import axios from 'axios';

export default function ShippingAddressFile({ shippingaddressorder, setShippingAddressorder, selectedOrgId, onSelectAddress, onCustomerData, transformedAddress, copiedShippingAddress, setShippingAddresses, shippingAddresses, contactInformation, setSelectedAddressIndex, selectedAddressIndex }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [shippingAddress, setShippingAddress] = useState({
    line1: '',
    line2: '',
    pincode: '',
    city: '',
    state: '',
    addressid: ''
  });
  const [errors, setErrors] = useState({});




  useEffect(() => {
    if (selectedOrgId) {
      axios.get(`${process.env.REACT_APP_MYBACKEND_PI}/api/customer/customershipping/address/${selectedOrgId}`)
        .then((response) => {
          setShippingAddresses(response.data);
        })
      setSelectedAddressIndex(null);
    }
  }, [selectedOrgId]);
  useEffect(() => {
    if (copiedShippingAddress) {
      setShippingAddress(copiedShippingAddress);
      const newAddress = {
        id: Date.now(),
        ...copiedShippingAddress
      };
      if (copiedShippingAddress && selectedOrgId !== null) {
        axios.put(`${process.env.REACT_APP_MYBACKEND_PI}/api/customer/customers/${selectedOrgId}/shipping-address`, copiedShippingAddress)
          .then((res) => {
            console.log(res.data)
          })
          .catch((err) => {
            console.error(err);
          });
      }
      setShippingAddresses(prevAddresses => [...prevAddresses, newAddress]);
      setSelectedAddressIndex(shippingAddresses.length);
      onSelectAddress(newAddress);
    }
  }, [copiedShippingAddress]);
  useEffect(() => {
    setShippingAddressorder(shippingAddresses)
  }, [shippingAddresses])
  useEffect(() => {
    if (transformedAddress) {
      setShippingAddress(transformedAddress);
      setShippingAddresses(prevAddresses => [...prevAddresses, { ...transformedAddress, id: Date.now() }]);
    }
  }, [transformedAddress]);



  const handleDeleteAddress = (index) => {
    setShippingAddresses(prevAddresses => prevAddresses.filter((_, i) => i !== index));
    // console.log(index,"jitu")
    if (selectedAddressIndex === index) {
      setSelectedAddressIndex({});
      onSelectAddress({});
    }
  };

  const handleCheckboxChange = (index) => {
    if (selectedAddressIndex === index) {
      setSelectedAddressIndex(null);
      onSelectAddress({});
    } else {
      setSelectedAddressIndex(index);
      onSelectAddress(shippingAddresses[index]);
    }
  };


  const handleAddShippingAddress = () => {
    setShippingAddress('');
    setIsPopupOpen(true);
  };



  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setShippingAddress({
      line1: '',
      line2: '',
      pincode: '',
      city: '',
      state: '',
      contactPerson: contactInformation.contactPerson,
      contactNumber: contactInformation.contactNumber,

    });
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setShippingAddress(prev => ({ ...prev, [name]: value }));
  };
  const handleFormSubmit = (e) => {
    // console.log(shippingAddress)
    e.preventDefault();

    // Validate form inputs
    const newErrors = {
      line1: !shippingAddress.line1?.trim(),
      line2: !shippingAddress.line2?.trim(),
      pincode: !shippingAddress.pincode?.trim(),
      city: !shippingAddress.city?.trim(),
      state: !shippingAddress.state?.trim(),
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    const newAddress = {
      line1: shippingAddress.line1.trim(),
      line2: shippingAddress.line2.trim(),
      pincode: shippingAddress.pincode.trim(),
      city: shippingAddress.city.trim(),
      state: shippingAddress.state.trim(),
      contactPerson: contactInformation.contactPerson,
      contactNumber: contactInformation.contactNumber,
    };


    if (selectedOrgId !== null) {
      axios.put(`${process.env.REACT_APP_MYBACKEND_PI}/api/customer/customers/${selectedOrgId}/shipping-address`, newAddress)
        .then((res) => {

          setShippingAddresses(prevAddresses => [...prevAddresses, newAddress]); // Update local state
          handleClosePopup(); // Close the form popup/modal
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setShippingAddresses(prevAddresses => [...prevAddresses, newAddress]); // Update local state
      handleClosePopup();
    }

  };



  const STATES = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
    "Ladakh",
    "Jammu and Kashmir"
  ];


  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-6">
      <h3 className="text-lg font-semibold mb-4">
        Shipping Addresses <span style={{ color: "red" }}>*</span>
      </h3>
      <div className="flex flex-wrap">
        {shippingAddresses.length > 0 ? (
          shippingAddresses.map((address, index) => (
            <div
              key={address.id}
              className="mr-4 w-64 h-48 rounded overflow-hidden shadow-lg border-2 border-primary mb-6 flex flex-col"
            >
              <div className="px-6 py-4 flex-grow flex flex-col">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={selectedAddressIndex === index}
                    onChange={() => handleCheckboxChange(index)}
                    className="mr-2"
                  />
                  <div className="font-bold text-xl mb-2">Shipping Address</div>
                </div>
                <p
                  className="text-gray-700 text-base overflow-hidden flex-grow"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {address.line1}, {address.line2}, {address.city}, {address.state} - {address.pincode}
                </p>
              </div>
              <div className=''>
                <button className='ml-4 p-3 text-red-600' onClick={() => handleDeleteAddress(index)} >Delete</button>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500 italic mb-4">No shipping addresses added yet.</p>
        )}
      </div>
      <div className="mt-4">
        <button
          onClick={handleAddShippingAddress}
          className="bg-white text-primary border border-primary py-2 px-4 rounded focus:outline-none focus:shadow-outline hover:bg-primary hover:text-white transition-colors duration-300"
        >
          + Add Shipping Address
        </button>
        <ShippingAddressPopup
          isOpen={isPopupOpen}
          onClose={handleClosePopup}
          editMode={false}
          shippingAddress={shippingAddress}
          handleInputChange={handleInputChange}
          handleFormSubmit={handleFormSubmit}
          errors={errors}
          STATES={STATES}
        />
      </div>
    </div>
  );
}